export default {
  inserted(el, binding, vnode) {
    let timer = null
    let isHovered = false
    let mouseX = 0
    let mouseY = 0
    const itemClass = el.getAttribute('data-class')
    const filePreview = el.closest(`.${itemClass}`) // 获取最近的 .file-preview 容器

    // 监听鼠标移动事件
    const mouseMoveHandler = (e) => {
      if (!filePreview) return

      // 获取 .file-preview 的位置
      const previewRect = filePreview.getBoundingClientRect()
      // 计算相对于 .file-preview 的位置
      mouseX = e.clientX - previewRect.left
      mouseY = e.clientY - previewRect.top
    }

    el.addEventListener('mousemove', mouseMoveHandler)

    el.addEventListener('mouseenter', () => {
      isHovered = true
      timer = setTimeout(() => {
        if (isHovered) {
          const itemId = el.getAttribute('data-item-id') // 获取当前元素的 item.id
          let item ={}
          if (itemId) {
            item = vnode.context.value.find(item => item.id.toString() === itemId) // 查找对应的 item 对象
          }
          binding.value({
            context: vnode.context,
            x: mouseX,
            y: mouseY,
            item: item // 推送当前元素的数据
          })
        }
      }, 2000) // 2秒延迟
    })

    el.addEventListener('mouseleave', () => {
      isHovered = false
      clearTimeout(timer)
      // 触发关闭显示
      if (vnode.context.hideTooltip) {
        vnode.context.hideTooltip()
      }
    })

    // 清理事件监听器
    el._cleanup = () => {
      el.removeEventListener('mousemove', mouseMoveHandler)
    }
  },
  unbind(el) {
    if (el._cleanup) {
      el._cleanup()
    }
  }
}
